import { Component } from '@angular/core';
import { SelectItem, LazyLoadEvent, Message, ConfirmationService } from 'primeng/api';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { DataTable } from "primeng/components/datatable/datatable";
import { JobAdmition } from '../../../../models/inModels/JobAdmition';
import { JobAdmitionService } from '../../../../services/business/job-admition.service';
import { NotificationContentType } from '../../../../models/inModels/MessageModel';


@Component({
	selector: 'app-job-admition',
	templateUrl: './job-admition.component.html',
	styleUrls: ['./job-admition.component.css']
})
export class JobAdmitionComponent {
	jobAdmition: JobAdmition[];
	rows: SelectItem[];
	selectedRows: number;
	filteredRecords: number;
	rowEvent: LazyLoadEvent;
	loading: boolean;
	totalRecords: number;
	error: Message[];
	contentId: number;
	contentType: NotificationContentType;
	sendAllDialog = false;
	constructor(
		private admitionService: JobAdmitionService,
		private route: ActivatedRoute,
		private router: Router,
		private confirmationService: ConfirmationService) {
		this.loading = true;
		this.rows = [];
		this.rows.push({ label: '10', value: 10 });
		this.rows.push({ label: '25', value: 25 });
		this.rows.push({ label: '50', value: 50 });
		this.selectedRows = 10;

		console.log(this.route.snapshot);
	}

	changeRows(event): void {
		this.load(this.rowEvent);
	}

	reset(dt: DataTable, gb: HTMLInputElement) {
		gb.value = '';
		dt.reset();
	}

	load(event: LazyLoadEvent): void {
		this.loading = true;
		event.rows = this.selectedRows;
		this.rowEvent = event;
		this.admitionService.search(event).then(
			dataPager => {
				this.jobAdmition = dataPager.Data;
				this.filteredRecords = dataPager.FilteredRecords;
				this.totalRecords = dataPager.TotalRecords;
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.jobAdmition = [];
				this.totalRecords = 0;
				this.filteredRecords = 0;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

	edit(jobAdmition: JobAdmition) {
		console.log(jobAdmition);
		this.router.navigate(['sales/admition/edit', jobAdmition.Id]);
	}

	sendAllDialogOpen(jobAdmition: JobAdmition) {
		this.contentId = jobAdmition.Id;
		this.contentType = NotificationContentType.Sale;
		this.sendAllDialog = true;
	}

	delete(jobAdmition: JobAdmition) {
		console.log(jobAdmition);
		this.confirmationService.confirm({
			message: `Are you sure you want to delete ${jobAdmition.CompanyName}'s admition?`,
			header: 'Confirmation',
			icon: 'fa fa-trash-o',
			accept: () => {
				this.loading = true;
				this.admitionService.delete(jobAdmition.Id).then(
					result => {
						this.loading = false;
						this.load(this.rowEvent);
					},
					error => {
						this.loading = false;
						this.error = [];
						this.error.push({ severity: 'error', summary: 'Error', detail: error });
					});
			}
		})
	}
}




// WEBPACK FOOTER //
// ./src/app/components/sales/job-admition/job-admition/job-admition.component.ts